import React, { useState } from 'react';
import { Competition } from '../models';
import { CompetitionSearchQuery, SimilarityType } from '../services/DataService';
import { LocalStorageDataService } from '../services/LocalStorageDataService';
import './AdvancedSearchContainer.css';
import AdvancedSearch from './AdvancedSearch';
import SimilaritySearch from './SimilaritySearch';
import CompetitionResults from './CompetitionResults';

const AdvancedSearchContainer: React.FC = () => {
  const [searchResults, setSearchResults] = useState<Competition[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<'advanced' | 'similarity'>('advanced');
  const [similarityType, setSimilarityType] = useState<SimilarityType>(SimilarityType.ALL);
  
  const dataService = new LocalStorageDataService();
  
  const handleAdvancedSearch = async (query: CompetitionSearchQuery) => {
    setIsLoading(true);
    
    try {
      const results = await dataService.searchCompetitions(query);
      setSearchResults(results);
    } catch (error) {
      console.error('検索中にエラーが発生しました:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleSimilarCompetitionsFound = (competitions: Competition[]) => {
    setSearchResults(competitions);
  };
  
  const handleFindSimilar = async (slug: string) => {
    setIsLoading(true);
    
    try {
      const results = await dataService.findSimilarCompetitions(slug, similarityType);
      setSearchResults(results);
      setActiveTab('similarity');
    } catch (error) {
      console.error('類似コンペの検索中にエラーが発生しました:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="advanced-search-container">
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === 'advanced' ? 'active' : ''}`}
          onClick={() => setActiveTab('advanced')}
        >
          高度な検索
        </button>
        <button
          className={`tab-button ${activeTab === 'similarity' ? 'active' : ''}`}
          onClick={() => setActiveTab('similarity')}
        >
          類似性検索
        </button>
      </div>
      
      <div className="tab-content">
        {activeTab === 'advanced' ? (
          <AdvancedSearch
            onSearch={handleAdvancedSearch}
            isLoading={isLoading}
          />
        ) : (
          <SimilaritySearch
            onSimilarCompetitionsFound={handleSimilarCompetitionsFound}
          />
        )}
      </div>
      
      <div className="results-section">
        <CompetitionResults
          competitions={searchResults}
          onFindSimilar={handleFindSimilar}
          selectedSimilarityType={similarityType}
        />
      </div>
    </div>
  );
};

export default AdvancedSearchContainer;
